import { render } from "./LogoIgbw.vue?vue&type=template&id=f70eeab6&scoped=true"
const script = {}

import "./LogoIgbw.vue?vue&type=style&index=0&id=f70eeab6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f70eeab6"

export default script